export default {
	state: {
		email: {}
	},
	getters: {
		"email": state => state.email
	},
	mutations: {
		setEmail(state, payload) {
			state.email = payload
		}
	},
	actions: {
		atualizarEstadoEmail({ commit }, payload) {
			commit('setEmail', payload)
		}
	}
};